import { styled, alpha } from '@mui/material/styles';
import MuiButton from '@mui/lab/LoadingButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import StyledBox from '../Box/StyledBox';

const Button = styled(MuiButton)(({ theme }) => ({
    border: '1px solid',
    fontWeight: 500,
    borderRadius: '25px',
    minWidth: '125px',
    fontSize: '1rem',
    // '&:hover': {
    //     backgroundColor: theme.palette.secondary.dark,
    //     color: '#fff',
    //     border: '1px solid ' + theme.palette.secondary.grey,
    //     // border: 'none',
    // },

    border: 'none',
}));

const RegistrationButton = (props) => {
    const {
        children,
        ...rest
    } = props;

    return (
        <Button
            {...rest}
        >
            {children}
        </Button>
    )
}


export default RegistrationButton